"use strict";

define('controller/submission/letter.detail',['require','exports','module','underscore','marionette','../base','uikit/uikit','view/text.editor','templates','config','model/document','model/document.letter','model/document.decision','model/letter.template','model/letter.tag','collection/assignments','libs/bind.helper','libs/route.helper','appkit/loader.helper','appkit/changes.helper','langs','evisions/redactor.plugins/macro.redactor.plugin','evisions/redactor.plugins/disabled.redactor.plugin'],function (require, exports, module) {
  var _ = require('underscore'),
    Mn = require('marionette'),
    RegionController = require('../base'),
    UIKit = require('uikit/uikit'),
    TextEditor = require('view/text.editor'),
    Templates = require('templates'),
    config = require('config'),
    Document = require('model/document'),
    DocumentLetterModel = require('model/document.letter'),
    DocumentDecisionModel = require('model/document.decision'),
    LetterTemplate = require('model/letter.template'),
    LetterTag = require('model/letter.tag'),
    Assignments = require('collection/assignments'),
    BindHelper = require('libs/bind.helper'),
    RouteHelper = require('libs/route.helper'),
    LoaderHelper = require('appkit/loader.helper'),
    ChangesHelper = require('appkit/changes.helper'),
    langs = require('langs');
  require('evisions/redactor.plugins/macro.redactor.plugin');
  require('evisions/redactor.plugins/disabled.redactor.plugin');
  var InputView = UIKit.Input;
  var DropdownView = UIKit.Dropdown;
  var TokenInputView = UIKit.TokenInput;
  var p = langs.phrase;
  function generateLetterDetailLink(model) {
    return RouteHelper.createLink(model.isNew() ? 'submission:letterCreate' : 'submission:letterDetail', model, model.isNew() ? {
      documentId: 'documentId'
    } : {
      documentId: 'documentId',
      letterId: 'id'
    });
  }
  ;
  function navigateLetterDetail(model) {
    app.navigate(generateLetterDetailLink(model).slice(1), {
      trigger: true
    });
  }
  ;
  var RootView = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    useInjector: true,
    template: Templates.IRB['document.letter.detail']
  });
  var SubmissionLetterDetailController = RegionController.extend({
    header: 'Letter Details',
    onStart: function onStart() {
      var app = this.app,
        region = this.region,
        state = this.state;
      var root = new RootView(),
        submissionService = app.service('submission'),
        documentId = state.get('documentId'),
        doc = new Document({
          id: documentId
        }),
        decisions = DocumentDecisionModel.openByDocumentId(documentId),
        letterModel = new DocumentLetterModel({
          id: state.get('letterId')
        }),
        assignments = new Assignments().params({
          entityType: 'document',
          entityId: state.get('documentId')
        }),
        changesHelper = new ChangesHelper().add(letterModel),
        loaderHelper = new LoaderHelper([letterModel]),
        tags = LetterTag.all(),
        letterTemplates = LetterTemplate.allByTemplateTypeId(),
        form = root.form,
        pageModels = null,
        popup = null,
        breadcrumb = root.breadcrumb;
      function unbindAll() {
        this.stopListening().off();
      }
      function generateSubject(letterTemplate) {
        return doc.get('studyLabel') + ' - ' + doc.get('templateType') + ': ' + letterTemplate.get('name');
      }
      function generateTokensFromEmails(data) {
        var emails = _.isString(data) ? data.split(';') : data,
          tokens = [];
        for (var i = 0, numOfEmails = emails.length; i < numOfEmails; i++) {
          if (emails[i]) {
            tokens.push({
              text: emails[i]
            });
          }
        }
        return tokens;
      }
      function generateEmailsFromTokens(tokens) {
        return tokens.pluck('text').join(';');
      }
      root.$el.css(config.contentCss);
      breadcrumb.collection = new Backbone.Collection([{
        text: 'Studies',
        link: RouteHelper.createLink('study:list')
      }, {
        text: 'Study Detail'
      }, {
        text: 'Submission Details'
      }, {
        text: 'Letters'
      }, {
        text: app.title
      }]);
      new BindHelper(new RouteHelper('study:detail').add(doc, {
        studyId: 'studyId'
      }), breadcrumb.collection.at(1)).bind('link', 'link').listenTo(root, 'destroy', unbindAll).transfer();
      new BindHelper(new RouteHelper('submission:detail').add(doc, {
        documentId: 'id',
        studyId: 'studyId'
      }), breadcrumb.collection.at(2)).bind('link', 'link').listenTo(root, 'destroy', unbindAll).transfer();
      new BindHelper(new RouteHelper('submission:letters').add(doc, {
        documentId: 'id'
      }), breadcrumb.collection.at(3)).bind('link', 'link').listenTo(root, 'destroy', unbindAll).transfer();
      var redactorOptions = _.extend({}, config.redactorDefaults, {
        name: 'text',
        placeholder: p('LetterDetail.Placeholder.Content'),
        plugins: ['macro', 'disabled'],
        macros: tags
      });
      var toFieldTokenInput = new TokenInputView({
          name: 'recipients',
          placeholder: ''
        }),
        ccFieldTokenInput = new TokenInputView({
          name: 'cc',
          placeholder: ''
        }),
        bccFieldTokenInput = new TokenInputView({
          name: 'bcc',
          placeholder: ''
        }),
        letterTemplatesDD = new DropdownView({
          name: 'letterTemplate'
        });
      form.addField({}).getOption('parent').addField({
        text: 'To:',
        required: true
      }, toFieldTokenInput).getOption('parent').addField({
        text: 'CC:'
      }, ccFieldTokenInput).getOption('parent').addField({
        text: 'BCC:'
      }, bccFieldTokenInput).getOption('parent').addField({
        text: 'Letter Template:',
        required: true
      }, letterTemplatesDD).getOption('parent').addField({
        text: 'Subject:',
        required: true
      }, new InputView({
        name: 'subject'
      })).getOption('parent').addField({}, new TextEditor(redactorOptions));
      form.model = letterModel;
      form.bindings.text = 'content';
      form.bindings.subject = 'subject';
      form.cc.getOption('parent').visible = false;
      form.bcc.getOption('parent').visible = false;
      letterTemplatesDD.placeholder = 'Select a Template';
      letterTemplatesDD.collection = letterTemplates;
      letterTemplatesDD.model = letterModel;
      letterTemplatesDD.bindings.value = 'letterTemplate';
      letterTemplatesDD.childBindings.text = 'name';
      root.save.icon = 'save';
      root.save.text = p('LetterDetail.SaveButton');
      root.save.model = new LoaderHelper([letterModel], {
        delay: 0
      });
      root.save.bindings.loading = 'loading';
      root.save.disabled = true;
      root["delete"].disabled = true;
      root["delete"].text = p('LetterDetail.DeleteButton');
      letterModel.labels.recipients = 'To field';
      letterModel.labels.letterTemplate = 'Letter Template';
      root.listenTo(form.recipients, 'token:remove token:add token:revised', function () {
        letterModel.set('recipients', generateEmailsFromTokens(form.recipients.collection));
      });
      root.listenTo(form.cc, 'token:remove token:add token:revised', function () {
        letterModel.set('cc', generateEmailsFromTokens(form.cc.collection));
      });
      root.listenTo(form.bcc, 'token:remove token:add token:revised', function () {
        letterModel.set('bcc', generateEmailsFromTokens(form.bcc.collection));
      });
      var unsavedModalEvents = app.request('modal', {
        type: 'UNSAVED_CHANGES',
        state: changesHelper
      }, {
        ariaControlsId: 'submissionLetterDetails'
      });
      root.on('save:press', function () {
        var _letterModel$get;
        var content = letterModel.get('content');
        if (letterModel && letterModel !== null && letterModel !== void 0 && letterModel.get('decision') && !(letterModel !== null && letterModel !== void 0 && (_letterModel$get = letterModel.get('decision')) !== null && _letterModel$get !== void 0 && _letterModel$get.isExpirationDateVisible())) {
          letterModel.set('content', content === null || content === void 0 ? void 0 : content.replace('[DECISION_EXPIRATION_DATE]', '--'));
        }
        letterModel.save();
      }).on('preview:press', function () {
        popup = app.request('pdf:popup');
        letterModel.replaceText();
      }).on('delete:press', function () {
        app.request('modal', {
          type: 'CONFIRM_DESTROY',
          state: state,
          name: form.model.get('name'),
          entity: 'Submission Letter'
        }, {
          ariaControlsId: 'submissionLetterDetails'
        }).on('confirm', function () {
          letterModel.destroy({
            wait: true
          });
        });
      }).on('cc:press', function () {
        if (form.cc.getOption('parent').visible = !form.cc.getOption('parent').visible) {
          form.cc.ui.input.focus();
        } else {
          letterModel.set('cc', '');
        }
      }).on('bcc:press', function () {
        if (form.bcc.getOption('parent').visible = !form.bcc.getOption('parent').visible) {
          form.bcc.ui.input.focus();
        } else {
          letterModel.set('bcc', '');
        }
      }).listenTo(form.bcc.getOption('parent'), 'change:visible', function () {
        root.bcc.active = form.bcc.getOption('parent').visible;
      }).listenTo(form.cc.getOption('parent'), 'change:visible', function () {
        root.cc.active = form.cc.getOption('parent').visible;
      }).listenTo(unsavedModalEvents, 'save:model', function () {
        letterModel.save();
      }).listenTo(changesHelper, 'change:' + ChangesHelper.UNSAVED_CHANGES, function () {
        root.save.disabled = !changesHelper.get(ChangesHelper.UNSAVED_CHANGES);
      }).listenTo(loaderHelper, 'change:loading', function () {
        form.state = loaderHelper.get('loading') ? 'loading' : '';
      });
      root.listenTo(letterModel, 'replace:content', function (model, content) {
        submissionService.createLetterPDF(content, popup);
      }).listenTo(letterModel, 'validated', function (valid, model, invalid) {
        if (!valid && invalid && invalid.letterTemplate) {}
      }).listenTo(doc, 'sync', function () {
        letterTemplates.params({
          templateTypeId: doc.get('templateTypeId')
        }).fetch();
        tags.params({
          templateType: doc.get('templateType')
        }).fetch();
      }).listenTo(decisions, 'sync', function () {
        if (decisions.length > 0) {
          letterModel.set('decision', decisions.at(0));
        }
      }).listenTo(assignments, 'sync', function () {
        if (letterModel.isNew()) {
          var emails = _.chain(Document.RESEARCH_TEAM_ASSIGNMENTS).reduce(function (memory, type) {
            return memory.concat(assignments.getByAssignmentTypeProp(type, 'description').models);
          }, []).invoke('get', 'primaryEmail').compact().sortBy(function (email) {
            return String(email).toLowerCase();
          }).uniq(true, function (email) {
            return String(email).toLowerCase();
          }).value();
          form.recipients.collection.reset(generateTokensFromEmails(emails));
          letterModel.set('recipients', emails.join('; '));
        }
      }).listenTo(letterModel, 'destroy', function () {
        app.navigate(RouteHelper.createLink('submission:letters', doc, {
          documentId: 'id'
        }).slice(1), {
          trigger: true
        });
      }).listenTo(letterModel, 'sync', function () {
        form.recipients.collection.reset(generateTokensFromEmails(letterModel.get('recipients')));
        form.cc.collection.reset(generateTokensFromEmails(letterModel.get('cc')));
        form.bcc.collection.reset(generateTokensFromEmails(letterModel.get('bcc')));
        if (letterModel.get('cc')) {
          form.cc.getOption('parent').visible = true;
        }
        if (letterModel.get('bcc')) {
          form.bcc.getOption('parent').visible = true;
        }
        root["delete"].disabled = false;
      }).on('destroy', function () {
        changesHelper.off().stopListening();
        loaderHelper.off().stopListening();
      });
      if (letterModel.isNew()) {
        letterModel.set('document', doc.clone());
        root.listenTo(letterModel, 'sync', function () {
          state.changeRouteName('submission:letterDetail').set({
            documentId: letterModel.get('documentId'),
            letterId: letterModel.id
          });
          letterTemplatesDD.disabled = true;
          root.render();
        }).listenToOnce(form.recipients, 'show', _.debounce(function () {
          form.recipients.ui.input.focus();
        }, 200));
        pageModels = [decisions, doc, assignments, letterTemplates];
        decisions.fetch();
        assignments.fetch();
      } else {
        pageModels = [letterModel, doc, letterTemplates];
        letterTemplatesDD.disabled = true;
        letterModel.fetch();
      }
      state.addPageDependencies(pageModels).on('page:loaded', function () {
        region.show(root);
        changesHelper.reset();
        root.listenTo(letterTemplatesDD, 'change:value', function () {
          var selectedLetterTemplate = letterTemplatesDD.value;
          if (selectedLetterTemplate && letterModel.isNew()) {
            form.text.value = selectedLetterTemplate.get('content');
            form.subject.value = generateSubject(selectedLetterTemplate);
          }
        });
      }).on('page:error', function () {
        app.navigate(RouteHelper.createLink('submission:letters', doc, {
          documentId: 'id'
        }).slice(1), {
          trigger: true
        });
      });
      doc.fetch();
    }
  });
  module.exports = SubmissionLetterDetailController;
});

